import { render, staticRenderFns } from "./myAlert.vue?vue&type=template&id=3cd4866a&scoped=true"
import script from "./myAlert.vue?vue&type=script&lang=js"
export * from "./myAlert.vue?vue&type=script&lang=js"
import style0 from "./myAlert.vue?vue&type=style&index=0&id=3cd4866a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4866a",
  null
  
)

export default component.exports